import { B3Tag } from '@/components';
import { useB3Lang } from '@b3/lang';

interface StatusProps {
  code: number;
}

interface InvoiceStatusProps {
  [key: string]: {
    [key: string]: string;
  };
}


export default function InvoiceStatus(props: StatusProps) {
  const { code } = props;

  const b3Lang = useB3Lang();

  const getInvoiceStatus = (code: number) => {
    const invoiceStatus: InvoiceStatusProps = {
      1: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.notReleased'),
        color: '#F1C224',
      },
      3: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.released'),
        color: '#516FAE',
      },
      4: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.releaseDiscarded'),
        color: '#C4DD6C',
      },
      5: {
        textColor: '#FFFFFF',
        name: b3Lang('invoice.releaseStatus.releaseCanceled'),
        color: '#D32F2F',
      },
    };

    const statusInfo = invoiceStatus[code] || {};

    return statusInfo;
  };

  const status = getInvoiceStatus(code);

  return status.name ? (
    <B3Tag color={status.color} textColor={status.textColor}>
      {status.name}
    </B3Tag>
  ) : null;
}
